import JSIdentifyIntro from "../../../../contents/docs/_snippets/identify-intro.mdx";
import JSIdentifyHowItWorks from "../../../../contents/docs/_snippets/identify-how-it-works";
import JSIdentifyWhenToCall from "../../../../contents/docs/_snippets/identify-when-to-call.mdx";
import JSIdentifyUseUniqueIds from "../../../../contents/docs/_snippets/identify-use-unique-ids.mdx";
import JSIdentifyReset from "../../../../contents/docs/_snippets/identify-reset.mdx";
import JSIdentifySetUserProperties from "../../../../contents/docs/_snippets/identify-setting-user-properties.mdx";
import JSIdentifyCrossPlatform from "../../../../contents/docs/_snippets/identify-cross-platform.mdx";
import * as React from 'react';
export default {
  JSIdentifyIntro,
  JSIdentifyHowItWorks,
  JSIdentifyWhenToCall,
  JSIdentifyUseUniqueIds,
  JSIdentifyReset,
  JSIdentifySetUserProperties,
  JSIdentifyCrossPlatform,
  React
};